var _circle, _circle2, _rect, _rect2, _g, _rect3, _rect4, _g2, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewAvatar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1312_6005)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5395,
    cy: 13.5395,
    r: 13.5395,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 35.7969 7.24951)",
    fill: "#955543"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2829,
    cy: 11.2829,
    r: 11.2829,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 34.0449 15.2637)",
    fill: "#F89F86"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.49052,
    height: 5.38862,
    rx: 2.24526,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 19.8984 25.7041)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1312_6005",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 25,
    width: 5,
    height: 7
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.49052,
    height: 5.38862,
    rx: 2.24526,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 19.8984 25.7041)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1312_6005)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.69431,
    height: 3.59241,
    rx: 1.34716,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 19.0312 26.6387)",
    fill: "#343434"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.49071,
    height: 5.38885,
    rx: 2.24535,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 29.4102 25.7031)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1312_6005",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 25,
    width: 6,
    height: 7
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.49071,
    height: 5.38885,
    rx: 2.24535,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 29.4102 25.7031)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1312_6005)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.69442,
    height: 3.59256,
    rx: 1.34721,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 28.543 26.6387)",
    fill: "#343434"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0332 23.7188L29.0748 23.7188",
    stroke: "#955543",
    strokeWidth: 1.47233,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 23.769L19.5612 23.769",
    stroke: "#955543",
    strokeWidth: 1.47233,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1777 32.0225C24.1777 32.0225 24.1657 32.8071 23.0561 33.4478",
    stroke: "#F36E49",
    strokeWidth: 0.88,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9233 29.7408L21.071 26.9156C21.1506 26.7198 21.428 26.7198 21.5075 26.9156L22.6553 29.7408C23.0486 30.7089 22.3343 31.7673 21.2893 31.7673C20.2443 31.7673 19.53 30.7089 19.9233 29.7408Z",
    fill: "#EA7656"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.18922,
    cy: 2.49234,
    rx: 2.18922,
    ry: 2.49234,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 37.75 27.5371)",
    fill: "#F89F86"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5483,
    cy: 28.6019,
    rx: 2.18922,
    ry: 2.49234,
    transform: "rotate(-30 10.5483 28.6019)",
    fill: "#F89F86"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.6816,
    cy: 24.8087,
    rx: 4.78421,
    ry: 1.57721,
    transform: "rotate(75 11.6816 24.8087)",
    fill: "#955543"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.78421,
    cy: 1.57721,
    rx: 4.78421,
    ry: 1.57721,
    transform: "matrix(-0.258819 0.965926 0.965926 0.258819 33.0195 19.7793)",
    fill: "#955543"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.27959,
    cy: 4.48542,
    rx: 6.27959,
    ry: 4.48542,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 12.7969 12.8403)",
    fill: "#955543"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.9562,
    cy: 20.4528,
    rx: 6.27959,
    ry: 4.48542,
    transform: "rotate(45 33.9562 20.4528)",
    fill: "#955543"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0277,
    cy: 7.16263,
    rx: 10.0277,
    ry: 7.16263,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 34.5156 6.35742)",
    fill: "#955543"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1312_6005"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.00195312,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewAvatar1);
export default __webpack_public_path__ + "static/media/review_avatar_1.e988f3100c387cc507cebb80b44203ac.svg";
export { ForwardRef as ReactComponent };